export default "__VITE_ASSET__CRME9yTY__"